<template>
  <div>
    <div class="alert alert-danger alert-dismissable" role="alert" v-if="message">
      <button type="button" class="close" data-dismiss="alert" aria-label="Close">
        <span aria-hidden="true">×</span>
      </button>
      <p class="mb-0">{{ message }}</p>
    </div>

    <div class="row row-deck">
      <div class="col-12 col-sm-8 flex-column order-2 order-sm-1 order-lg-0">
        <div class="block d-flex flex-column flex-fill">
          <template v-if="post.post_request && post.post_request.status !== 2">
            <div class="block-header block-header-default">
              <h3 class="block-title">Artikel aanvraag</h3>
            </div>
            <div class="block-content">
              <div class="form-group">
                <bs-input
                  label="Titel"
                  name="title"
                  classname="js-maxlength"
                  maxlength="90"
                  :maxlengthShow="true"
                  v-model="post.title"
                  :disabled="true"
                ></bs-input>
              </div>
              <div class="form-group">
                <bs-textarea
                  label="Korte omschrijving"
                  :disabled="true"
                  rows="3"
                  classname="js-maxlength"
                  maxlength="150"
                  :maxlengthShow="true"
                  placeholder="Beschrijf hier uw wensen voor het artikel"
                  name="post_request.description"
                  v-model="post.post_request.description"
                ></bs-textarea>
              </div>
              <div class="form-group">
                <bs-input
                  label="Linktekst 1"
                  :disabled="true"
                  name="post_request.title"
                  classname="js-maxlength"
                  maxlength="42"
                  :maxlengthShow="true"
                  v-model="post.post_request.title"
                  helper="Geen www. toegestaan in de linktekst"
                ></bs-input>
              </div>
              <div class="form-group">
                <bs-input
                  label="Url 1"
                  :disabled="true"
                  name="post_request.url"
                  v-model="post.post_request.url"
                  helper="Geen Adult links toegestaan"
                ></bs-input>
              </div>
              <div class="form-group">
                <bs-input
                  label="Linktekst 2 (niet verplicht)"
                  :disabled="true"
                  name="post_request.optional_title"
                  classname="js-maxlength"
                  maxlength="42"
                  :maxlengthShow="true"
                  v-model="post.post_request.optional_title"
                  helper="Geen www. toegestaan in de linktekst"
                ></bs-input>
              </div>
              <div class="form-group">
                <bs-input
                  label="Url 2 (niet verplicht)"
                  :disabled="true"
                  name="post_request.optional_url"
                  v-model="post.post_request.optional_url"
                  helper="Geen Adult links toegestaan"
                ></bs-input>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="block-header block-header-default">
              <h3 class="block-title">Artikel</h3>
            </div>
            <div class="block-content d-flex flex-column flex-fill">
              <div class="form-group">
                <bs-input
                  label="Titel"
                  name="title"
                  classname="js-maxlength"
                  maxlength="90"
                  :maxlengthShow="true"
                  v-model="post.title"
                  :disabled="!editable"
                  helper="Geen www. toegestaan in de titel"
                ></bs-input>
              </div>
              <div class="form-group d-flex flex-column flex-fill">
                <label>Artikel</label>
                <bs-editor v-model="post.content" :editable="editable" />
                <div v-if="editor_error" class="invalid-feedback animated fadeIn d-block">{{ $t(editor_error) }}</div>
              </div>
            </div>
          </template>
        </div>
      </div>
      <div class="col-12 col-sm-4 flex-column order-1 order-sm-2">
        <div class="block w-100">
          <div class="block-header block-header-default">
            <h3 class="block-title">Acties</h3>
          </div>
          <div class="block-content">
            <div class="form-group d-flex justify-content-between">
              <a v-if="[3, 4].includes(post.status)" class="btn btn-outline-primary" :href="`https://${blog.name}/${post.slug}`" target="_blank">
                Artikel bekijken
              </a>
              <button type="submit" class="btn btn-primary" :disabled="!editable" v-on:click.prevent="submit">
                {{ post.status == 5 ? 'Opnieuw indienen' : 'Wijzigen' }}
              </button>
            </div>
          </div>
        </div>

        <div v-if="Object.values(errors).length > 0" class="block block-themed w-100">
          <div class="block-header block-header-default bg-danger">
            <h3 class="block-title">We zijn er bijna!</h3>
          </div>
          <div class="block-content">
            <p class="mb-0">De volgende punten moeten nog worden gedaan voor het artikel gepubliceerd kan worden:</p>
            <ul>
              <template v-for="error in errors">
                <li v-for="message in error">
                  {{ message }}
                </li>
              </template>
            </ul>
          </div>
        </div>

        <div class="accordion order-1 order-sm-0" id="accordion_information">
          <div class="block w-100">
            <a
              id="headingOne"
              href="#"
              class="block-header block-header-default"
              data-toggle="collapse"
              data-target="#collapseOne"
              aria-expanded="true"
              aria-controls="collapseOne"
            >
              <h3 class="block-title">Informatie</h3>
              <div class="block-options">
                <button type="button" class="btn-block-option">
                  <i class="fas fa-chevron-up"></i>
                </button>
              </div>
            </a>

            <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordion_information">
              <div class="block-content">
                <div class="form-group">
                  <bs-select
                    label="Blog"
                    name="blog_id"
                    classname="js-select2"
                    :options="[{ name: blog.name, value: blog.id }]"
                    v-model="blog.id"
                    :disabled="true"
                  ></bs-select>
                </div>
                <div class="form-group">
                  <bs-select
                    label="Pagina"
                    name="page_id"
                    classname="js-select2"
                    :options="[{ name: post.page.title, value: post.page.id }]"
                    :disabled="true"
                    v-model="post.page.id"
                  ></bs-select>
                </div>
                <div class="form-group">
                  <bs-input
                    type="date"
                    label="Uw artikel is/wordt gepubliceerd op"
                    name="started_at"
                    classname="js-flatpickr flatpickr-input"
                    :disabled="true"
                    v-model="post.started_at"
                  ></bs-input>
                </div>
                <bs-image-picker v-model="post.image_id" :disabled="!editable" name="image_id"></bs-image-picker>
              </div>
            </div>
          </div>
        </div>
        <div class="order-0 order-sm-1">
          <div class="block block-link-shadow text-center">
            <div class="block-header block-header-default">
              <h5 class="block-title font-size-sm">Besteld op:</h5>
            </div>
            <div class="block-content block-content-full">
              <div class="font-weight-bold">{{ post.created_at | date('DD-MM-YYYY HH:mm') }}</div>
            </div>
          </div>
          <div class="block block-link-shadow text-center mx-sm-4 mx-lg-0" v-if="post.claimed_at">
            <div class="block-header block-header-default">
              <h5 class="block-title font-size-sm">Geclaimed op:</h5>
            </div>
            <div class="block-content block-content-full">
              <div class="font-weight-bold">
                {{ post.claimed_at | date('DD-MM-YYYY HH:mm') }}
              </div>
            </div>
          </div>
          <div class="block block-link-shadow text-center" v-if="post.published_at">
            <div class="block-header block-header-default">
              <h5 class="block-title font-size-sm">Opgeleverd op:</h5>
            </div>
            <div class="block-content block-content-full">
              <div class="font-weight-bold">
                {{ post.published_at | date('DD-MM-YYYY HH:mm') }}
              </div>
            </div>
          </div>
          <div class="block block-link-shadow text-center" v-if="post.claimed_at && !post.published_at">
            <div class="block-header block-header-default">
              <h5 class="block-title font-size-sm">Uiterlijke oplevering:</h5>
            </div>
            <div class="block-content block-content-full">
              <div class="font-weight-bold">
                {{ moment(post.claimed_at).add(7, 'days') | date('DD-MM-YYYY HH:mm') }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios';

export default {
  props: {
    blog: {
      type: Object,
      required: true,
    },
    post: {
      type: Object,
      default: {},
    },
    message: {
      type: String,
      default: null,
    },
    redirect: {
      type: String,
      default: 'posts.index',
    },
  },
  data: () => {
    return {
      links: [],
      errors: [],
      editor: null,
    };
  },
  computed: {
    editable: function() {
      if (this.post.status === 4) {
        return false;
      }

      if (this.post.post_request && this.post.post_request.status !== 2) {
        return false;
      }

      return true;
    },
    editor_error: function() {
      if (this.errors && this.errors['content']) {
        return this.errors['content'][0];
      }
    },
  },
  methods: {
    submit: function() {
      var errors = {};

      // Check if text minimum 350 words?
      let text = this.post.content.replace(/<[^>]+>/g, '');
      if (text.trim().split(/\s+/).length < 347) {
        if (!errors['content']) errors['content'] = [];
        errors['content'].push('Het artikel moet minimaal 350 woorden bevatten.');
      }
      // Check max 2 links
      var doc = document.createElement('html');
      doc.innerHTML = this.post.content;
      var links = doc.getElementsByTagName('a');
      if (links && links.length > 2) {
        if (!errors['content']) errors['description'] = [];
        errors['content'].push('Het artikel mag maximaal 2 linkjes bevatten.');
      }

      if (links) {
        Array.from(links).forEach((link) => {
          if (link.text.length > 42) {
            if (!errors['content']) errors['description'] = [];
            errors['content'].push('De anchors mogen maximaal 42 tekens bevatten.');
          }
        });
      }

      if (text.includes('https://')) {
        if (!errors['content']) errors['content'] = [];
        errors['content'].push('Het artikel mag geen `https://` bevatten.');
      }

      if (text.includes('www.')) {
        if (!errors['description']) errors['description'] = [];
        errors['description'].push('Het artikel mag geen `www.` bevatten.');
      }

      this.errors = errors;

      if (Object.keys(this.errors).length === 0) {
        axios
          .put(route('posts.update', this.blog.id, this.post.id), {
            title: this.post.title,
            content: this.post.content,
            image_id: this.post.image_id,
          })
          .then((response) => {
            if (response.status == 200 && response.data) {
              this.errors = response.data.errors;
              this.message = response.data.message;
              if (response.data.success) {
                window.location.href = route('posts.index');
              }
            }
          });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
#accordion_information {
  .block-header {
    .btn-block-option {
      transition: transform 0.35s ease;
    }

    &.collapsed {
      .btn-block-option {
        transform: rotate(180deg);
      }
    }
  }
}
</style>
